import React, {useEffect, useState} from 'react';
import Layout from "../components/Layout";
import Header from "../components/Header";
import NavigationDropdown from "../components/NavigationDropdown";
import {mdiAlertCircle} from "@mdi/js";
import Icon from "@mdi/react";
import logoDarkMode from "../assets/header-dark.png";
import logoLightMode from "../assets/header-light.png";
import {useManageContext} from "../App";
import {AddressType, findNextStop} from "../types/Address";
import {useParams, useSearchParams} from "react-router-dom";
import {getTaskTypeName, TaskType} from "../types/Task";
import TaskComponent from "../components/Task";
import NotYourNextStopFeedback from "../components/NotYourNextStopFeedback";

export default function ActiveTrip() {

    const {tripKey, taskGuid} = useParams();

    const {isDarkMode, trip, lang} = useManageContext();
    const [address, setAddress] = useState<AddressType | null | undefined>(null);
    const [taskTypeName, setTaskTypeName] = useState('');
    const [isNextStop, setIsNextStop] = useState(false);
    const [searchParams] = useSearchParams();

    const TourId = searchParams.get('TourId');

    useEffect(() => {
        if (trip) {
            setAddress(trip.Address.find((Address: AddressType) => Address.Tasks.find((Task: TaskType) => Task.TaskGuid === taskGuid)));
        }
    }, [trip, taskGuid]);

    useEffect(() => {
        if (address) {
            setTaskTypeName(address.AddressSequenceMain + '. ' + getTaskTypeName(address.TaskType, address?.AdditionalStopTypeId, lang));
        }
    }, [address, lang]);

    useEffect(() => {
        setIsNextStop(!trip || address?.AddressId === findNextStop(trip.Address)?.AddressId);
    },[address, trip]);

    if (typeof trip === "undefined" || typeof address === "undefined") {
        return <div className="main d-flex justify-content-center align-items-center">
            <div className="text-center">
                <img className="mb-3" src={isDarkMode ? logoDarkMode : logoLightMode} alt="CLOUDEX Tracking" style={{maxHeight: 35}}/>
                <div className="d-flex">
                    <div className="alert alert-danger">
                        <Icon path={mdiAlertCircle} size={1}/> <strong>No Trip or Address found!</strong>
                        <p className="mt-2 mb-0">Please make sure you are using the correct url to access your trip.</p>
                    </div>
                </div>
            </div>
        </div>;
    }

    return (
        <Layout>
            <Header backUrl={'/' + tripKey + (TourId ? '?TourId=' + TourId : '')} title={taskTypeName}>
                <div className="d-flex align-items-center justify-content-end">
                    <NavigationDropdown address={address}/>
                </div>
            </Header>
            <div className="bg-primary-container px-4 pt-4 border-bottom">
                <NotYourNextStopFeedback visible={!isNextStop} />
                <div dangerouslySetInnerHTML={{__html: address?.FullAddressHtml ?? ''}}></div>
                <div className="pt-4"></div>
            </div>
            {address?.Tasks.filter((Task: TaskType) => Task.TaskCompletedDate === '').map((Task: TaskType) =>
                <TaskComponent key={'task-' + Task.TaskGuid} Task={Task}/>)}
        </Layout>
    );
}